import React, { useState, useEffect } from 'react';
import Stars from '../Components/Stars';
import Price from '../Components/Price';
import * as Icons from '../Components/Icons';
import {Link, useParams} from "react-router-dom"
import {FiPlusCircle, FiLogIn, FiMusic} from "react-icons/fi"
import {MdChatBubble} from "react-icons/md"
import Status from '../Components/Status';
import CalendarDetail from '../Components/CalendarDetail';
import { roundUp } from '../functions/functions';

import { db, auth } from '../functions/firebaseFunctions'
const months = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

const ArtistPage = (  ) => {
  const [Err, setErr] = useState(null);
  const { artuid, type } =  useParams()
  const [info, setInfo] = useState(null);
  const [photo, setPhoto] = useState('/blank-profile-picture.png');
  const [art, setArt] = useState(null);

  const [events, setEvents] = useState(null);
  const [signed, setSigned] = useState(false);

  const [rating, setRating] = useState(null);
  const [Rqty, setRqty] = useState(0);
  const [price, setPrice] = useState(null);
  const [convId, setConvId] = useState(null);

  const [scsMsg, showScsMsg] = useState(false);

  const [booked, SetBooked] = useState(null);
  const uid = auth.currentUser?.uid
  useEffect(() => {
    getData();
    if (uid) {
    setSigned(true)
    const promises = [
        db.collection('conversations').where('userA', '==', uid).where('userB', '==', artuid).get(),
        db.collection('conversations').where('userA', '==', artuid).where('userB', '==', uid).get(),
    ];
    Promise.all(promises)
    .then(snapshots => {
        snapshots.forEach(snapshot => {
            snapshot.forEach(doc => {
                const convData = doc.data();
                console.log('convData',  convData);
                console.log('docid', doc.id);
                const convID = doc.id;
                setConvId(convID);
            });
        });
    });
  }
  }, []);

  const getData = () => {
    if (artuid) {
      // show artist info
      db.collection('users').doc(artuid).onSnapshot((doc) => {
        const val = doc.data();
        const Art = val.artist;
        setInfo(val);
        if (val.photo) { setPhoto({ uri: val.photo }); }
        if (Art) { setArt(Art); }

      });

      // find booked events for the calendar
      db.collection('services').doc(artuid).onSnapshot((doc) => {
        const val = doc.data();
        var count = 0;
        const arr = [];
        let ser = val.services.find(x => x.servicetype == type);
        // console.log('ser', ser)
        db.collection('services').doc(artuid).collection('events')
          .onSnapshot((doc) => {
            if (!doc.empty) {
              doc.docs?.forEach((e) => {
                let ev = e.data();
                count++;
                ev.id = ev.docid;
                arr.push(ev);
                if (count == doc.docs?.length) {
                  SetBooked(arr);
                }
              });

            }
          });

        if (ser) {
          setPrice(ser?.price);
        }
        const serviceId = artuid + '_' + type;

        //get ratings
        db.collection('ratings').doc('services').collection(serviceId).get().then((querySnapshot) => {
          if (!querySnapshot.empty) {
            let ratingsSum = 0;
            let ratingsQty = 0;
            querySnapshot.forEach((ratingDoc) => {
              let thisRating = ratingDoc.data().rating;
              ratingsSum = ratingsSum + thisRating;
              ratingsQty++;
            });
            let ratingsAvg = roundUp(ratingsSum / ratingsQty, 0.1);
            setRqty(ratingsQty);
            setRating(ratingsAvg);
          }
        }).catch(err => { setErr(err); });

        //if a viewer is signed in check if there are any events that this artist could be booked
        if (uid) {
          // console.log('uid', uid)
          db.collection('events').where('uid', '==', uid)
            .onSnapshot((r) => {
              const arrEv = [];
              let val = r.docs; 
              // console.log('val', val[0].data())
              const now = new Date();
              let f = val.filter((x) => {
                if (now < new Date(x.data().end.toDate())) {
                  return x;
                }
              });
              var count = 0;
              if (!r.empty) {
                val.forEach(x => {
                  x = x.data();
                  const date = new Date(x.start.toDate());
                  const now = new Date();
                  const end = new Date(x.end.toDate());
                  const day = date.getDate();
                  const month = months[date.getMonth()];
                  let status;
                  db.collection('bookings').doc(x.docid)
                    .onSnapshot((booking) => {
                      const res = booking.data();
                      db.collection('bookings').doc(x.docid).collection('etts').doc(artuid)
                        .onSnapshot((bookings) => {

                          if (bookings.exists) {
                            let res = bookings.data();
                            // console.log('ress', res)
                            status = res.status;
                          }
                          if (now < end) {
                            count++;

                            arrEv.push({
                              id: x.docid,
                              name: x.name,
                              type: x.type,
                              day: day,
                              month: month,
                              date: date,
                              end: end,
                              status: status,
                              host: res?.owner,
                              public: x.public,
                            });
                            // console.log('arrEv', arrEv)

                          }

                          if (f.length == count && count > 0) {
                            setEvents(arrEv);
                          }


                        });
                      // if(res && res.etts && res.etts[artuid]){status = res.etts[artuid].status}
                    });

                });
              }


            });
        }
      });
    }
  };
  return (
    <div className='EventScreen'>
      <div style={{display: 'flex', flexDirection: 'column', justifySelf: 'center', padding: 10,  width: '550px'}}>
        <div style={{display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
          <h1 style={{}}>{info && info.name}</h1>
          <h1 style={{marginInline: 20, color: 'var(--ltg)', animation: 'none', fontSize: '22px'}}>{type}</h1>
        </div>
        <div className='ArtistsPageSocialMedia'>
          {Err && <div style={{ color: 'red' }}><p style={{ color: 'red' }}>{Err.message}</p></div>}
          {scsMsg === true && <div style={{color:'white'}}><p style={{color:'white'}}>Request is sent</p></div>}
          <div className='ArtistsPageInfo' style={ { }}>
            {/* {console.log(photo)} */}
              <img alt='Profile_pitcture'
                src={photo.uri ? photo.uri : photo}
                // src={'/blank-profile-picture.png'}
                style={{ width: 120, height: 120, borderRadius: 5, margin: 10, objectFit: 'cover'}}
              />
            {/* <Image
              style={{ width: 80, height: 80, borderRadius: 5 }}
              source={photo}
            /> */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', paddingHorizontal: 10, height: '100%' }}>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', flex: 1 }}>
              {/* {console.log('price', price)} */}
              <Price price={price} />
              <Stars color={'var(--org)'} qty={Rqty} offset={rating / 5} id={type} />
              {console.log('convId', convId)}
              {info && <Link to={`/messages/${info.uid}%26${convId ? convId : 'new'}%26${info.name}`} style={{display: 'flex', flexDirection: 'row', justifyContent: 'center', cursor: 'pointer', }}>
                {/* {console.log('info', info)} */}
                  <p style={{  color: 'var(--wht)', fontWeight: 'bold', fontSize: 16, marginRight: 10 }}>Message</p>
                  <MdChatBubble name="message" size={24} color={'var(--wht)'} />
              </Link>}
              </div>
            </div>
          </div>
          {art && art.bio && <p style={{ color: 'var(--ltg)', alignSelf: 'center', margin: 10, fontSize: 16, textAlign: 'justify' }}>{art.bio}</p>}
          {info && <React.Fragment>
            <div style={{ display: 'flex', flexDirection: 'row', marginHorizontal: 10, alignItems: 'center', justifyContent: 'space-evenly' }}>
              {info && info.fb && 
              <a 
                href={`https://facebook.com/${info.fb}`} 
                target="_blank" 
                rel="noopener noreferrer" 
              >
                <Icons.FaceBook color={'var(--ltg)'} size={40} />
              </a>
              // </div>
              }
              {info && info.inst && 
              <a 
                href={`https://instagram.com/${info.inst}`} 
                target="_blank" 
                rel="noopener noreferrer"
              >
                <Icons.Instagram color={'var(--ltg)'} size={40} />
              </a>
              }
              {info && info.twit && 
              <a 
              href={`https://twitter.com/${info.twit}`} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Icons.Twitter color={'var(--ltg)'} size={40} />
            </a>
              }
              {info && info.in && 
              <a 
              href={`https://linkedin.com/in/${info.in}`} 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <Icons.LinkedIn color={'var(--ltg)'} size={40} />
            </a>
              }
            </div>
          </React.Fragment>}
          {art && (art.mix || art.yt || art.sp || art.sp) && <React.Fragment>
            <hr style={{ display: 'flex', borderBottom: '1px solid var(--ltg)', width: '100%', marginBlock: 5, alignItems: 'center', justifyContent: 'space-evenly'  }} />
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10,  alignItems: 'center',  }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flex: 1, borderRightWidth: 2, borderRightStyle: 'solid', color: 'var(--wht)', height: 40, position: 'absolute', marginInlineStart: -30, width: 75 }}>
                <FiMusic style={{colors: 'var(--wht)'}} size={30}/>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', flex: 4, justifyContent: 'space-evenly' }}>
                {art && art.sp && 
                  <a 
                  href={`https://open.spotify.com/artist/${art.sp}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Icons.Spotify color={'var(--wht)'} size={40} />
                </a>
                }
                {art && art.yt && 
                  <a 
                  href={`https://youtube.com/${art.yt}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Icons.YouTube color={'var(--wht)'} size={40} />
                </a>
                }
                {art && art.sc && 
                  <a 
                  href={`https://soundcloud.com/${art.sc}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Icons.SoundCloud color={'var(--wht)'} size={40} />
                </a>
                }
                {art && art.mix && 
                  <a 
                  href={`https://www.mixcloud.com/${art.mix}`} 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  <Icons.MixCloud color={'var(--wht)'} size={40} />
                </a>
                }
              </div>
            </div>
          </React.Fragment>}
        </div>
        <div style={{width: 320, display: 'flex', alignSelf: 'center', height: 230}}>
        <CalendarDetail serBks={booked} booked={true} />
        </div>
        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', marginBlock: 15 }}>
          {events && <div className='centered' style={{display: 'flex', flexDirection: 'column', cursor: 'pointer'}}>
            <p style={{ color: 'white',}}>Your Events:</p>
            {events.map(item => <div
              key={item.id}
              style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBlock: 5 }}
              onClick={() => {


                if (item.status) {

                  // navigation.navigate('Event', { eventId: item.id, uid: artuid, type: item.type });
                } else {
                  if (booked) {
                    for (const event of Object.values(booked)) {
                      const start = new Date(event.start).valueOf();
                      const end = new Date(event.end).valueOf();
                      const newEventStart = new Date(item.date).valueOf();
                      if (newEventStart >= start && newEventStart < end) {
                        setErr({ code: 'timeConf', message: "You can't book this venue at for the selectd event because of the time conflict" });
                      } else {
                        setEvents(null);
                        let update = {};
                        update = { name: info.name, price: price, status: 'Requested', type: type, docid: artuid };
                        db.collection('bookings').doc(item.id)
                          .collection('etts').doc(artuid).set(update).then(() => {
                            db.collection('services').doc(artuid)
                              .collection('events').doc(item.id).set({
                                start: item.date,
                                docid: item.id,
                                end: item.end,
                                name: item.public ? item.name : null,
                                type: item.public ? item.type : null,
                                host: uid,
                              }, { merge: true })
                              .then(() => {
                                showScsMsg(true);
                              }).catch(e => { setErr(e); });
                          }).catch(e => { setErr(e); });

                      }
                    }
                  } else {
                    setEvents(null);
                    let update = {};
                    update = { name: info.name, price: price, status: 'Requested', type: type, docid: artuid };

                    db.collection('bookings').doc(item.id).collection('etts').doc(artuid).set(update);
                    db.collection('services').doc(artuid).collection('events').doc(item.id).set({
                      start: item.date,
                      end: item.end,
                      docid: item.id,
                      name: item.public ? item.name : null,
                      type: item.public ? item.type : null,
                      host: uid,
                    }).then(() => {
                      showScsMsg(true);
                    }).catch((err) => console.log('Err', err));

                  }
                }
              }}>
              <p style={{ color: 'white', marginInline: 10 }}>{item.month} {item.day} - {item.name}  |</p>
              <Status status={item.status} />
            </div>)}
          </div>}
          {signed == true && !events && 
          <button style={{ alignSelf: 'center', color: 'white'}} onClick={() => { console.log('navigete to edit event') }}>
            Create an event to book the artists <FiPlusCircle />
          </button>
          // <Btn icon={{ name: 'plus-circle', position: 'right' }} style={{ alignSelf: 'center' }} title="Create an event to book the artists" color="white" onClick={() => { navigation.navigate('Edit Event', { eventId: 'new', uid: uid }); }} />
        }
          {signed == false &&
          <button className='BrowseButton' style={{marginBlock: 10}}>
          Log in to book the artists  <FiLogIn style={{marginInline: 10, fontSize: 16}}/>
          </button>
          // <Btn icon={{ name: 'log-in', position: 'right' }} style={{ alignSelf: 'center' }} title="Log in to book the artists" color="white" onClick={() => { navigation.navigate('Home'); }} />
          }
        </div>
      </div>
    </div>
  );
};

export default ArtistPage;
